module.exports = __webpack_public_path__ + "img/left.6d9285d3.svg";